// Webpack Imports
import * as bootstrap from 'bootstrap';

import Swiper, {Navigation, Pagination, Autoplay, Scrollbar} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar]);

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();


(function ($) {

    // header swiper
    if( $('.header-swiper .swiper').length > 0 ) {
        var headerSwiper = new Swiper(".header-swiper .swiper", {
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: ".swiper-pagination",
            },
        });
    }

    // product-slider swiper
    $('.product-slider .swiper-container.swiper-3-products').each(function (index) {
        var swiperProducts = new Swiper($(this)[0], {
            modules: [Navigation],
            autoplay: {
                delay: 4000,
            },
            lazy: true,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    });
    $('.product-slider .swiper-container.swiper-1-product').each(function (index) {
        var swiperProducts = new Swiper($(this)[0], {
            modules: [Navigation],
            lazy: true,
            slidesPerView: 1,
            autoplay: {
                delay: 3500,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    });

// Trusts swiper
    $('.trust .swiper-container').each(function (index) {
        var swiperTrust = new Swiper($(this)[0], {
            modules: [Pagination],
            centeredSlides: true,
            preloadImages: false,
            lazy: true,

            loop: true,
            loopFillGroupWithBlank: true,

            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },

            autoplay: {
                delay: 2000,
            },

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                992: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
            },

        });
    });


    $(document).ready(function () {
        $(".has-megamenu .nav-link").click(function (e) {
            window.location.href = $(this).attr('href');
        });

        $('.dropdown-menu.megamenu').mouseover(function () {
            $(this).prev().addClass('show');
        }).mouseout(function () {
            $(this).prev().removeClass('show');
        });

        var isHide = true;
        $('#search-mobile').click(function () {
            if(isHide) {
                $('.header-block-product-search').fadeIn();
                isHide = false;
            }else{
                $('.header-block-product-search').fadeOut();
                isHide = true;
            }
        });
    });

})(jQuery);